export const localeCompare = (a: string, b: string, locale = 'de') => {
  return a.localeCompare(b, locale);
};
